// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//

require("jquery")
require("@rails/ujs").start();
require("jquery-ui")
require("@rails/activestorage").start();
require("@nathanvda/cocoon")
require("bootstrap")

import $ from "jquery/dist/jquery";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/toast";
import "bootstrap/js/dist/tooltip";
import "bootstrap/js/dist/util";
import "bootstrap-datepicker";


import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import { data } from "jquery";

const application = Application.start();
const context = require.context("controllers", true, /.js$/);
application.load(definitionsFromContext(context));

document.addEventListener("turbolinks:load", function() {
  window.loaded = true;
  application.controllers
    .filter(function(c) {
      return c.identifier == "selectr";
    })
    .forEach(function(controller) {
      if (typeof controller.initialize === "function") {
        controller.initialize();
      }
    });
});

document.addEventListener("turbolinks:before-cache", function() {
  window.loaded = null;
  application.controllers
    .filter(function(c) {
      return c.identifier == "selectr";
    })
    .forEach(function(controller) {
      if (typeof controller.disconnect === "function") {
        controller.disconnect();
      }
    });
});

$(document).ready(function($) {
  $('#all_employee_select').change(function(){
    var id = $(this).val()
    $.ajax({
      url: "/admin/companies/" + id + "/get_specific_managers",
      type: "POST",
    }).done(function() {
      $('#hiring_manager_id').select2();
      $('.select2-multiple').select2({
        allowClear: false,
        multiple: true
      })
    });
  });

  $('#carouselExampleSlidesOnly').on('slid.bs.carousel', function () {
    var currentIndex = $('.rounded-circle.active').index() + 1;
    var totalItems = $('.by_guest_speaker-count').text().split('/')[1]
    $('.by_guest_speaker-count').html('('+currentIndex+'/'+totalItems+'');
  });

  $(document).on("click", ".clickable-row", function() {
    window.location = $(this).data("href");
  });

  $(document).on("click", ".scroll-down-wrapper", function() {
    var element = document.getElementById("explore-industry");
    element.scrollIntoView({ behavior: "smooth" });
  });

  $(document).on("click", "#guest-modal", function() {
    var link = $(location).attr("href").split("?")[0];
    link = link + "?guest_speaker_id=" + $("#guest_speaker_modal-id").val();
    window.location.replace(link);
  });
});

$(document).on("click", ".dropleft", function() {
  $(this).parent().toggleClass('show');
  $(this).attr('aria-expanded', true);
  $(this).next().toggleClass('show');
});

function sendAjaxRequest(url, courseId) {
  $.ajax({
    url: url,
    type: "GET",
    dataType: 'script',
    data: {
      course_id: courseId
    }
  });
}

$(document).on("change", "#funder-course-select", function() {
  var url = '/funders/dashboard/regional_course';
  var courseId = $(this).val();
  sendAjaxRequest(url, courseId);
});

$(document).on("change", "#funder-local-course-select", function() {
  var url = '/funders/dashboard/local_view_course';
  var courseId = $(this).val();
  sendAjaxRequest(url, courseId);
});

$(document).on("change", "#funder-national-course-select", function() {
  var url = '/funders/dashboard/national_course';
  var courseId = $(this).val();
  sendAjaxRequest(url, courseId);
});

function initializeCareerFairForm(formId, thankYouMessageId, eventDate, eventTime, calendarTitle) {
  const careerFairForm = document.getElementById(formId);
  const nextBtn = careerFairForm ? careerFairForm.querySelector("#nextBtn") : null;
  const thankYouMessageEl = document.getElementById(thankYouMessageId);
  const addToCalendarBtn = thankYouMessageEl ? thankYouMessageEl.querySelector("#addToCalendarBtn") : null;

  if (!careerFairForm || !thankYouMessageEl || !nextBtn) return;

  let formPayload = null;

  function getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute("content");
  }

  nextBtn.addEventListener("click", async () => {
    if (careerFairForm.checkValidity()) {
      careerFairForm.reportValidity();
      nextBtn.disabled = true;

      const formData = new FormData(careerFairForm);
      formPayload = {
        name: formData.get("career_fairs[name]"),
        email: formData.get("career_fairs[email]"),
        phone: formData.get("career_fairs[phone]"),
        company_name: formData.get("career_fairs[company_name]"),
        message: formData.get("career_fairs[message]"),
        event_date: eventDate,
        event_time: eventTime,
      };
      console.log('formPayload:', formPayload);

      try {
        const railsResponse = await fetch("/career_fairs", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": getCsrfToken(),
          },
          body: JSON.stringify({ career_fairs: formPayload }),
        });

        const railsData = await railsResponse.json();

        if (!railsResponse.ok || !railsData.success) {
          console.error("Rails submission failed:", railsData.errors);
          alert("An unexpected error occurred during submission.");
          return;
        }

        careerFairForm.style.display = "none";
        thankYouMessageEl.style.display = "block";

        if (addToCalendarBtn) {
          const details = `Career Fair registration. Name: ${formPayload.name}`;
          const location = "Epping Forest Civic Offices";

          const calendarLink = buildGoogleCalendarLink(calendarTitle, details, location, eventDate, eventTime);
          addToCalendarBtn.href = calendarLink;
        }

        careerFairForm.reset();
      } catch (error) {
        console.error("Submission error:", error);
        alert("An unexpected error occurred during submission.");
      } finally {
        nextBtn.disabled = false;
      }
    } else {
      careerFairForm.reportValidity();
    }
  });
}

function initializeCareerPartnerForm(formId, thankYouMessageId, eventDate, eventTime, calendarTitle) {
  const careerPartnerForm = document.getElementById(formId);
  const nextBtn = careerPartnerForm ? careerPartnerForm.querySelector("#nextBtn") : null;
  const thankYouMessageEl = document.getElementById(thankYouMessageId);
  const addToCalendarBtn = thankYouMessageEl ? thankYouMessageEl.querySelector("#addToCalendarBtn") : null;

  if (!careerPartnerForm || !thankYouMessageEl || !nextBtn) return;

  let formPayload = null;

  function getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute("content");
  }

  nextBtn.addEventListener("click", async () => {
    if (careerPartnerForm.checkValidity()) {
      careerPartnerForm.reportValidity();
      nextBtn.disabled = true;

      const formData = new FormData(careerPartnerForm);
      formPayload = {
        name: formData.get("career_partner[name]"),
        email: formData.get("career_partner[email]"),
        phone: formData.get("career_partner[phone]"),
        business_name: formData.get("career_partner[business_name]"),
        message: formData.get("career_partner[message]"),
        event_date: eventDate,
        event_time: eventTime,
      };

      try {
        const railsResponse = await fetch("/career_partners", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": getCsrfToken(),
          },
          body: JSON.stringify({ career_partner: formPayload }),
        });

        const railsData = await railsResponse.json();

        if (!railsResponse.ok || !railsData.success) {
          console.error("Rails submission failed:", railsData.errors);
          alert("An unexpected error occurred during submission.");
          return;
        }

        careerPartnerForm.style.display = "none";
        thankYouMessageEl.style.display = "block";

        if (addToCalendarBtn) {
          const details = `Meeting scheduled via Career Partner form. Business Name: ${formPayload.business_name}`;
          const location = "Epping Forest Civic Offices";

          const calendarLink = buildGoogleCalendarLink(calendarTitle, details, location, eventDate, eventTime);
          addToCalendarBtn.href = calendarLink;
        }

        careerPartnerForm.reset();
      } catch (error) {
        console.error("Submission error:", error);
        alert("An unexpected error occurred during submission.");
      } finally {
        nextBtn.disabled = false;
      }
    } else {
      careerPartnerForm.reportValidity();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeCareerFairForm("careerFairForm", "thankYouMessage", "2026-01-29", "09:00", "West Essex Health & Care Careers Fair");
  initializeCareerPartnerForm("careerPartnerForm", "thankYouModal", "2025-11-05", "09:00", "West Essex Health & Care Conference");
});

function toGoogleCalendarFormat(dateTime) {
  const year = dateTime.getFullYear();
  const month = String(dateTime.getMonth() + 1).padStart(2, '0');
  const day = String(dateTime.getDate()).padStart(2, '0');
  const hours = String(dateTime.getHours()).padStart(2, '0');
  const minutes = String(dateTime.getMinutes()).padStart(2, '0');
  const seconds = String(dateTime.getSeconds()).padStart(2, '0');
  return `${year}${month}${day}T${hours}${minutes}${seconds}`;
}

function buildGoogleCalendarLink(title, details, location, startDate, startTime) {
  const startDateTime = new Date(`${startDate}T${startTime}`);
  const endDateTime = new Date(startDateTime.getTime());
  endDateTime.setHours(endDateTime.getHours() + 4);

  const start = toGoogleCalendarFormat(startDateTime);
  const end = toGoogleCalendarFormat(endDateTime);

  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(location)}&dates=${start}/${end}`;
}
